import { getDominantColorFromImage, isHexColor } from "ui-tools"

export const getIslandColor = async (
  storedColor: string | null | undefined,
  imageSrc: string | null | undefined,
  fallbackColor: string
) => {
  if (isHexColor(storedColor)) return storedColor

  return getDominantColorFromImage(imageSrc).catch(() => fallbackColor)
}
